import * as React from 'react';
import { useSelector } from 'react-redux';
import { SafeRentDescriptionContainer } from '../../components/SafeRentDescription';
import { EDealRentVersion } from '../../repositories/offer-card/entities/offer/OfferSchema';
import { DealRentDescriptionV1Container } from '../../components/DealRentDescriptionV1';
import { dealVersionSelector } from '../../selectors/offerData/offer/dealVersion';

export const DealRentDescriptionContainer = () => {
  const dealVersion = useSelector(dealVersionSelector);

  switch (dealVersion) {
    case EDealRentVersion.V2:
      return <SafeRentDescriptionContainer />;
    case EDealRentVersion.V1:
    default:
      return <DealRentDescriptionV1Container />;
  }
};
